import { useRouteLoaderData, useSearchParams } from '@remix-run/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SubscriberGate } from '~/components/Actions/types';
import Signup from '~/components/Signup';
import Text from '~/components/Text';

const SubscribePrompt = () => {
  const { signupWidgetConfigs } = useRouteLoaderData<any>('root');
  const [email, setEmail] = useState('');
  const [, setSearchParams] = useSearchParams();
  const { t } = useTranslation();

  return (
    <div className="rounded bg-gray-100 p-8">
      <div className="mb-6 flex flex-col items-center space-y-3">
        <Text
          as="h1"
          type="title"
          size="3xl"
          theme={'default'}
          className="w-full break-words text-center leading-tight tracking-normal"
        >
          {t('forms.subscribers_only')}
        </Text>
        <Text as="p" type="body" theme={'default'} className="text-md text-center tracking-wide opacity-75 sm:text-lg">
          {t('forms.subscribers_only_description')}
        </Text>
      </div>
      <Signup
        signupStyles={signupWidgetConfigs}
        onEmailChange={setEmail}
        type={SubscriberGate.FORM}
        onSuccess={() => {
          setSearchParams({ email });
        }}
      />
    </div>
  );
};

export default SubscribePrompt;
